export function extractText (html: string) {
  const element = document.createElement('div')
  element.innerHTML = html || ''

  const text = element.innerText || element.textContent || ''
  return text.trim()
}
